import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-mapeamento", {
        attrs: {
          acesso: _vm.acesso,
          fim: _vm.fimPeriodo,
          inicio: _vm.inicioPeriodo,
          titulo: _vm.tituloPagina,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.prazoAtual || _vm.prazoEsgotado
                  ? _c(
                      VCol,
                      { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                      [
                        _c(
                          VTabs,
                          {
                            attrs: { centered: "", "icons-and-text": "" },
                            model: {
                              value: _vm.categoria,
                              callback: function ($$v) {
                                _vm.categoria = $$v
                              },
                              expression: "categoria",
                            },
                          },
                          [
                            _c(VTabsSlider, {
                              attrs: { color: "secondary" },
                            }),
                            _vm._l(_vm.categorias.length, function (i) {
                              return _c(
                                VTab,
                                {
                                  key: i,
                                  staticClass: "mt-3",
                                  attrs: {
                                    href: "#" + _vm.categorias[i - 1].id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey--text text--darken-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.categorias[i - 1].descricao)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VIcon,
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        color:
                                          _vm.categorias[i - 1].id ===
                                          _vm.categoria
                                            ? "secondary"
                                            : "grey",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.categorias[i - 1].icone) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                        _c(
                          VTabsItems,
                          {
                            model: {
                              value: _vm.categoria,
                              callback: function ($$v) {
                                _vm.categoria = $$v
                              },
                              expression: "categoria",
                            },
                          },
                          [
                            _c(
                              VTabItem,
                              { attrs: { value: "responsabilidades" } },
                              [
                                _c(
                                  VRow,
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      VCol,
                                      [
                                        _c(
                                          VRow,
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              VToolbar,
                                              { attrs: { flat: "" } },
                                              [
                                                _c(VToolbarTitle, [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "title primary--text text--darken-1 text-no-wrap mt-0",
                                                    },
                                                    [_vm._v(" FILTROS ")]
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VRow,
                                          [
                                            _c(VAutocomplete, {
                                              staticClass: "mx-2",
                                              attrs: {
                                                "item-text":
                                                  _vm.getUnidadeSiglaAndNome,
                                                items: _vm.unidades,
                                                "search-input":
                                                  _vm.pesquisaUnidade,
                                                label: "Unidade(s):",
                                                placeholder:
                                                  "Digite para pesquisar...",
                                                multiple: "",
                                                "prepend-icon":
                                                  "account_balance",
                                                "return-object": "",
                                              },
                                              on: {
                                                "update:searchInput": function (
                                                  $event
                                                ) {
                                                  _vm.pesquisaUnidade = $event
                                                },
                                                "update:search-input":
                                                  function ($event) {
                                                    _vm.pesquisaUnidade = $event
                                                  },
                                                change: function ($event) {
                                                  _vm.pesquisaUnidade = ""
                                                },
                                                input:
                                                  _vm.loadResponsabilidades,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  _vm.unidades.length > 0
                                                    ? {
                                                        key: "prepend-item",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              VListItem,
                                                              {
                                                                on: {
                                                                  click:
                                                                    _vm.toggleItens,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  VListItemAction,
                                                                  [
                                                                    _c(
                                                                      VIcon,
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            _vm
                                                                              .filtros
                                                                              .unidades
                                                                              .length >
                                                                            0
                                                                              ? "primary"
                                                                              : "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.icon
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  VListItemContent,
                                                                  [
                                                                    _c(
                                                                      VListItemTitle,
                                                                      [
                                                                        _vm._v(
                                                                          " Selecionar Todas "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(VDivider, {
                                                              staticClass:
                                                                "mt-2",
                                                            }),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      }
                                                    : null,
                                                  {
                                                    key: "selection",
                                                    fn: function (data) {
                                                      return [
                                                        _c(
                                                          VChip,
                                                          {
                                                            staticClass:
                                                              "chip--select-multi",
                                                            attrs: {
                                                              "input-value":
                                                                data.selected,
                                                              close: "",
                                                              color: "primary",
                                                              search: "",
                                                              small: "",
                                                              "text-color":
                                                                "white",
                                                            },
                                                            on: {
                                                              "click:close":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.removeUnidade(
                                                                    data.item
                                                                  )
                                                                },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  data.item
                                                                    .sigla
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: _vm.filtros.unidades,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filtros,
                                                    "unidades",
                                                    $$v
                                                  )
                                                },
                                                expression: "filtros.unidades",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              {
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  VRow,
                                                  {
                                                    attrs: { "no-gutters": "" },
                                                  },
                                                  [
                                                    _c(VSelect, {
                                                      staticClass: "mr-4",
                                                      attrs: {
                                                        items: _vm.situacoes,
                                                        "item-text":
                                                          "descricao",
                                                        "item-value": "id",
                                                        label: "Situação:",
                                                        "prepend-icon":
                                                          "filter_list",
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.loadResponsabilidades,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.filtros.situacao,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.filtros,
                                                            "situacao",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "filtros.situacao",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              {
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  VRow,
                                                  {
                                                    attrs: { "no-gutters": "" },
                                                  },
                                                  [
                                                    _c("app-sort", {
                                                      model: {
                                                        value: _vm.opcoes,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.opcoes = $$v
                                                        },
                                                        expression: "opcoes",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              {
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c("app-search", {
                                                  model: {
                                                    value: _vm.opcoes,
                                                    callback: function ($$v) {
                                                      _vm.opcoes = $$v
                                                    },
                                                    expression: "opcoes",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VToolbar,
                                              { attrs: { flat: "" } },
                                              [
                                                _c(VToolbarTitle, [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "title primary--text text--darken-1 text-no-wrap mb-4",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " RESPONSABILIDADES (" +
                                                          _vm._s(
                                                            _vm
                                                              .responsabilidades
                                                              .length
                                                          ) +
                                                          ") "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      VCol,
                                      [
                                        _c(VDataTable, {
                                          staticClass: "elevation-0",
                                          attrs: {
                                            headers: _vm.headers,
                                            items: _vm.responsabilidades,
                                            search: _vm.opcoes.pesquisa,
                                            "sort-by": _vm.opcoes.ordenarPor,
                                            "sort-desc": _vm.opcoes.decrescente,
                                            "item-key": "id",
                                            "show-expand": "",
                                            "show-select": "",
                                            "single-expand": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: `header.data-table-select`,
                                                fn: function ({ on, props }) {
                                                  return [
                                                    _c(
                                                      VSimpleCheckbox,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm
                                                                    .responsabilidades
                                                                    .length >
                                                                    0 &&
                                                                  _vm.prazoAtual,
                                                                expression:
                                                                  "responsabilidades.length > 0 && prazoAtual",
                                                              },
                                                            ],
                                                            attrs: {
                                                              disabled:
                                                                _vm.filtros
                                                                  .situacao ===
                                                                  "CONSOLIDADAS" ||
                                                                _vm.filtros
                                                                  .situacao ===
                                                                  "EXCLUIDAS",
                                                              color: "primary",
                                                            },
                                                            on: {
                                                              input:
                                                                _vm.toggleAllCheckboxes,
                                                            },
                                                          },
                                                          "v-simple-checkbox",
                                                          props,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.data-table-select`,
                                                fn: function ({
                                                  isSelected,
                                                  select,
                                                  item,
                                                }) {
                                                  return [
                                                    _c(VSimpleCheckbox, {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: _vm.prazoAtual,
                                                          expression:
                                                            "prazoAtual",
                                                        },
                                                        {
                                                          def: Ripple,
                                                          name: "ripple",
                                                          rawName: "v-ripple",
                                                        },
                                                      ],
                                                      attrs: {
                                                        disabled:
                                                          (_vm.tipoNormalizacao ===
                                                            "consolidacao" &&
                                                            item.consolidada) ||
                                                          (_vm.tipoNormalizacao ===
                                                            "normalizacao" &&
                                                            item.normalizada) ||
                                                          item.excluida,
                                                        value: isSelected,
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return select($event)
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.status`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      VCol,
                                                      [
                                                        _c(
                                                          VChip,
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.normalizada,
                                                                expression:
                                                                  "item.normalizada",
                                                              },
                                                            ],
                                                            staticClass: "mb-2",
                                                            attrs: {
                                                              color:
                                                                "secondary",
                                                              outlined: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Normalizada "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          VChip,
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.validada,
                                                                expression:
                                                                  "item.validada",
                                                              },
                                                            ],
                                                            staticClass: "mb-2",
                                                            attrs: {
                                                              color:
                                                                "purple lighten-2",
                                                              outlined: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [_vm._v(" Validada ")]
                                                        ),
                                                        _c(
                                                          VChip,
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.consolidada,
                                                                expression:
                                                                  "item.consolidada",
                                                              },
                                                            ],
                                                            staticClass: "mb-2",
                                                            attrs: {
                                                              color: "success",
                                                              outlined: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Consolidada "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          VChip,
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.excluida,
                                                                expression:
                                                                  "item.excluida",
                                                              },
                                                            ],
                                                            staticClass: "mb-2",
                                                            attrs: {
                                                              color: "error",
                                                              outlined: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Arquivada "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.data-table-expand`,
                                                fn: function ({
                                                  item,
                                                  expand,
                                                  isExpanded,
                                                }) {
                                                  return [
                                                    _c(
                                                      VTooltip,
                                                      {
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    VBtn,
                                                                    _vm._g(
                                                                      {
                                                                        attrs: {
                                                                          height:
                                                                            "100%",
                                                                          text: "",
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return expand(
                                                                                !isExpanded
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        VBadge,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              right:
                                                                                "",
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "badge",
                                                                                  fn: function () {
                                                                                    return [
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item
                                                                                                .competenciasAtuais
                                                                                                .length
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                  proxy: true,
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        },
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  color:
                                                                                    "grey lighten-0",
                                                                                  large:
                                                                                    "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " build "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Clique para exibir as competências técnicas"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "expanded-item",
                                                fn: function ({
                                                  headers,
                                                  item,
                                                }) {
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "justify-center",
                                                        attrs: {
                                                          colspan:
                                                            headers.length,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VRow,
                                                          [
                                                            _c(VSpacer),
                                                            _c(
                                                              VCol,
                                                              [
                                                                _c(
                                                                  VRow,
                                                                  {
                                                                    staticClass:
                                                                      "justify-center",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "h2",
                                                                      {
                                                                        staticClass:
                                                                          "title primary--text text--darken-1 text-no-wrap",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " COMPETÊNCIAS TÉCNICAS "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(VSpacer),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VRow,
                                                          [
                                                            _c(VSpacer),
                                                            _c(
                                                              VCol,
                                                              {
                                                                attrs: {
                                                                  cols: "10",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  VSimpleTable,
                                                                  {
                                                                    staticClass:
                                                                      "elevation-0 mb-4",
                                                                    attrs: {
                                                                      dense: "",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "default",
                                                                            fn: function () {
                                                                              return [
                                                                                _c(
                                                                                  "tbody",
                                                                                  _vm._l(
                                                                                    item
                                                                                      .colunasCompetencias
                                                                                      .lista,
                                                                                    function (
                                                                                      column
                                                                                    ) {
                                                                                      return _c(
                                                                                        "tr",
                                                                                        {
                                                                                          key: column.id,
                                                                                        },
                                                                                        _vm._l(
                                                                                          column,
                                                                                          function (
                                                                                            item
                                                                                          ) {
                                                                                            return _c(
                                                                                              "td",
                                                                                              {
                                                                                                key: item.id,
                                                                                                attrs:
                                                                                                  {
                                                                                                    width:
                                                                                                      "30%",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "d-flex flex-row ma-1",
                                                                                                  },
                                                                                                  [
                                                                                                    item
                                                                                                      .unidades
                                                                                                      .length ===
                                                                                                    0
                                                                                                      ? _c(
                                                                                                          "span",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "secondary--text",
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " " +
                                                                                                                _vm._s(
                                                                                                                  item.nomeAtual
                                                                                                                ) +
                                                                                                                " "
                                                                                                            ),
                                                                                                          ]
                                                                                                        )
                                                                                                      : _vm._e(),
                                                                                                    item
                                                                                                      .unidades
                                                                                                      .length >
                                                                                                    0
                                                                                                      ? _c(
                                                                                                          "span",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "grey-text text--darken-2",
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " " +
                                                                                                                _vm._s(
                                                                                                                  item.nomeAtual
                                                                                                                ) +
                                                                                                                " "
                                                                                                            ),
                                                                                                          ]
                                                                                                        )
                                                                                                      : _vm._e(),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          }
                                                                                        ),
                                                                                        0
                                                                                      )
                                                                                    }
                                                                                  ),
                                                                                  0
                                                                                ),
                                                                              ]
                                                                            },
                                                                            proxy: true,
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(VSpacer),
                                                          ],
                                                          1
                                                        ),
                                                        _c(VSpacer),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.tipo`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      VCol,
                                                      [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              "max-width":
                                                                "500",
                                                              top: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VChip,
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "ml-1",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "success white--text",
                                                                                label:
                                                                                  "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " Dificuldade " +
                                                                              _vm._s(
                                                                                item
                                                                                  .dificuldadeAtual
                                                                                  .valor
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item
                                                                    .dificuldadeAtual
                                                                    .descricao
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              "max-width":
                                                                "500",
                                                              top: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VChip,
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "ml-1",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "secondary white--text",
                                                                                label:
                                                                                  "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " Impacto " +
                                                                              _vm._s(
                                                                                item
                                                                                  .impactoAtual
                                                                                  .valor
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item
                                                                    .impactoAtual
                                                                    .descricao
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.acoes`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      VCol,
                                                      [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.isEditarBtnDisponivel,
                                                                                  expression:
                                                                                    "item.isEditarBtnDisponivel",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "mr-2",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "secondary",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.editItem(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "edit"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para editar a responsabilidade"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.isArquivarBtnDisponivel,
                                                                                  expression:
                                                                                    "item.isArquivarBtnDisponivel",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "mr-2",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "error",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.confirmDeleteItem(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "archive"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para arquivar a responsabilidade"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.isDesfazerBtnDisponivel,
                                                                                  expression:
                                                                                    "item.isDesfazerBtnDisponivel",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "mr-2",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  _vm.colorBtnDesfazer,
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.desfazer(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "settings_backup_restore"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para cancelar a " +
                                                                  _vm._s(
                                                                    _vm.nomeAcao
                                                                  ) +
                                                                  " da responsabilidade"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.excluida &&
                                                                                    _vm.prazoAtual,
                                                                                  expression:
                                                                                    "item.excluida && prazoAtual",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "mr-2",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "error",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.restaurarItem(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "settings_backup_restore"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para restaurar a responsabilidade"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.isLupaBtnDisponivel,
                                                                                  expression:
                                                                                    "item.isLupaBtnDisponivel",
                                                                                },
                                                                              ],
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "grey",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.visualizarItem(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  color:
                                                                                    "grey lighten-0",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " search "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para visualizar o histórico de edições da responsabilidade"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value:
                                              _vm.selectedResponsabilidades,
                                            callback: function ($$v) {
                                              _vm.selectedResponsabilidades =
                                                $$v
                                            },
                                            expression:
                                              "selectedResponsabilidades",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VTabItem,
                              { attrs: { value: "competencias" } },
                              [
                                _c(
                                  VRow,
                                  [
                                    _c("gerenciamento-competencias", {
                                      attrs: {
                                        etapa: _vm.tipoNormalizacao,
                                        mapeamento: _vm.mapeamento,
                                        unidades: _vm.unidades,
                                        "prazo-atual": _vm.prazoAtual,
                                      },
                                      model: {
                                        value: _vm.competenciasSelecionadas,
                                        callback: function ($$v) {
                                          _vm.competenciasSelecionadas = $$v
                                        },
                                        expression: "competenciasSelecionadas",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          { staticClass: "justify-end mb-1" },
                          [
                            _vm.categoria === "responsabilidades"
                              ? _c(
                                  VTooltip,
                                  {
                                    attrs: { "max-width": "400", top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      disabled:
                                                        _vm.responsabilidades
                                                          .length === 0,
                                                      color: "success",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.generateWorksheet()
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("get_app"),
                                                  ]),
                                                  _vm._v(" BAIXAR XLS "),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2592240820
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Clique para baixar os dados em formato XLS."
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.prazoAtual &&
                                            _vm.categoria ===
                                              "responsabilidades",
                                          expression:
                                            "prazoAtual && categoria === 'responsabilidades'",
                                        },
                                      ],
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "secondary",
                                        outlined: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.categoria = "competencias"
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c(VIcon, { staticClass: "mr-2" }, [
                                      _vm._v(" keyboard_arrow_left "),
                                    ]),
                                    _vm._v(" ANTERIOR "),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "Clique no botão para voltar para a normalização das competências."
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.prazoAtual &&
                                            _vm.categoria === "competencias",
                                          expression:
                                            "prazoAtual && categoria === 'competencias'",
                                        },
                                      ],
                                      staticClass: "mr-2",
                                      attrs: {
                                        disabled:
                                          _vm.competenciasSelecionadas.length <
                                          2,
                                        color: "primary",
                                      },
                                      on: {
                                        click:
                                          _vm.toggleAgruparCompetenciasSelecionadas,
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(" AGRUPAR "),
                                    _c(VIcon, { staticClass: "ml-2" }, [
                                      _vm._v(" folder_copy "),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "Clique no botão para voltar para agrupar as competências selecionadas."
                          ),
                        ]),
                      ]
                    ),
                    _vm.prazoAtual
                      ? _c(
                          VTooltip,
                          {
                            attrs: {
                              disabled:
                                _vm.selectedResponsabilidades.length === 0,
                              top: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.prazoAtual &&
                                                  _vm.categoria ===
                                                    "responsabilidades",
                                                expression:
                                                  "prazoAtual && categoria === 'responsabilidades'",
                                              },
                                            ],
                                            staticClass: "mr-2",
                                            attrs: {
                                              disabled:
                                                _vm.selectedResponsabilidades
                                                  .length === 0,
                                              color: "primary",
                                            },
                                            on: { click: _vm.consolidar },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.nomeBtnOperacao) +
                                              " "
                                          ),
                                          _c(
                                            VIcon,
                                            { staticClass: "ml-2" },
                                            [_vm._v(" folder_copy ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3074090886
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Clique no botão para " +
                                  _vm._s(_vm.nomeBtnOperacao.toLowerCase()) +
                                  " a(s) responsabilidade(s)"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.prazoAtual &&
                                            _vm.categoria ===
                                              "responsabilidades",
                                          expression:
                                            "prazoAtual && categoria === 'responsabilidades'",
                                        },
                                      ],
                                      attrs: {
                                        disabled:
                                          _vm.responsabilidades.length === 0,
                                        color: "secondary",
                                        outlined: "",
                                      },
                                      on: {
                                        click: _vm.toggleDialogAgradecimento,
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(" FINALIZAR "),
                                    _c(VIcon, { staticClass: "ml-2" }, [
                                      _vm._v(" check "),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "Clique no botão para finalizar a normalização das responsabilidades"
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.prazoAtual &&
                                            _vm.categoria === "competencias",
                                          expression:
                                            "prazoAtual && categoria === 'competencias'",
                                        },
                                      ],
                                      attrs: {
                                        color: "secondary",
                                        outlined: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.categoria = "responsabilidades"
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(" PRÓXIMO "),
                                    _c(VIcon, { staticClass: "ml-2" }, [
                                      _vm._v(" keyboard_arrow_right "),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "Clique no botão para seguir para a normalização das responsabilidades."
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        VDialog,
        {
          attrs: { "max-width": "370", persistent: "" },
          model: {
            value: _vm.dialogs.dialogRemove.visible,
            callback: function ($$v) {
              _vm.$set(_vm.dialogs.dialogRemove, "visible", $$v)
            },
            expression: "dialogs.dialogRemove.visible",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "headline" }),
              _c(VCardText, [
                _vm._v(
                  " Você realmente deseja arquivar essa responsabilidade? "
                ),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "error", text: "" },
                      on: { click: _vm.deleteItem },
                    },
                    [_vm._v(" Arquivar ")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "grey", text: "" },
                      on: { click: _vm.toggleDialogRemove },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogs.dialogEdit.visibilidade
        ? _c("edicao-responsabilidade", {
            attrs: {
              etapa: _vm.tipoNormalizacao,
              responsabilidade: _vm.dialogs.dialogEdit.item,
              dialog: _vm.dialogs.dialogEdit,
            },
            on: { updated: _vm.isUpdated },
          })
        : _vm._e(),
      _vm.dialogs.dialogHistorico.visibilidade
        ? _c("historico-responsabilidade", {
            attrs: {
              responsabilidade: _vm.dialogs.dialogHistorico.item,
              etapa: _vm.tipoNormalizacao,
              dialog: _vm.dialogs.dialogHistorico,
            },
          })
        : _vm._e(),
      _c("dialog-agradecimento", {
        attrs: {
          "dialog-visible": _vm.dialogs.dialogAgradecimento.visible,
          "toogle-visible": _vm.toggleDialogAgradecimento,
          descricao:
            "Agradecemos pela sua colaboração! Você ainda poderá participar da " +
            _vm.nomeAcao +
            " das responsabilidades até o período estabelecido.",
          "url-redirecionamento": "/gerenciamento",
        },
      }),
      _c(
        VDialog,
        {
          attrs: { "max-width": "600", persistent: "" },
          model: {
            value: _vm.agruparCompetenciasSelecionadasDialog,
            callback: function ($$v) {
              _vm.agruparCompetenciasSelecionadasDialog = $$v
            },
            expression: "agruparCompetenciasSelecionadasDialog",
          },
        },
        [
          _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.agruparCompetenciasSelecionadas.apply(
                    null,
                    arguments
                  )
                },
              },
            },
            [
              _c(
                VCard,
                { staticClass: "pa-4" },
                [
                  _c(
                    VCardTitle,
                    { staticClass: "headline primary--text text-no-wrap" },
                    [
                      _vm._v(
                        " Insira o novo nome para as competências abaixo: "
                      ),
                    ]
                  ),
                  _c(
                    VCardText,
                    [
                      _vm._l(
                        _vm.competenciasSelecionadasOrdenadas,
                        function (competencia) {
                          return _c(
                            VChip,
                            {
                              key: competencia.id,
                              staticClass: "mb-1 ml-1",
                              attrs: {
                                color: "grey",
                                small: "",
                                "text-color": "white",
                              },
                            },
                            [_vm._v(" " + _vm._s(competencia.nomeAtual) + " ")]
                          )
                        }
                      ),
                      _c(VTextField, {
                        attrs: {
                          hint: "Insira um nome que represente todas as competências a serem agrupadas",
                          label: "Nome da competência agrupadora",
                        },
                        model: {
                          value: _vm.nomeCompetenciaAgrupadora,
                          callback: function ($$v) {
                            _vm.nomeCompetenciaAgrupadora =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "nomeCompetenciaAgrupadora",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    VCardActions,
                    [
                      _c(VSpacer),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            disabled:
                              _vm.nomeCompetenciaAgrupadora.trim().length === 0,
                            color: "primary",
                            type: "submit",
                          },
                        },
                        [_vm._v(" Agrupar ")]
                      ),
                      _c(
                        VBtn,
                        {
                          attrs: { color: "primary", outlined: "" },
                          on: {
                            click: _vm.toggleAgruparCompetenciasSelecionadas,
                          },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }